import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function ChartPieSliceIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M9.563 10.266v-6.75a.563.563 0 0 0-.75-.531 9.56 9.56 0 0 0-6.215 10.758.563.563 0 0 0 .834.385l5.85-3.375a.56.56 0 0 0 .281-.488m-1.125-.329L3.595 12.73a8.45 8.45 0 0 1 4.843-8.379zm11.866-2.677-.023-.044-.026-.04A9.56 9.56 0 0 0 12 2.438a.563.563 0 0 0-.563.563v8.719l-7.481 4.356a.563.563 0 0 0-.202.77 9.563 9.563 0 0 0 16.549-9.585m-7.74-3.68a8.44 8.44 0 0 1 6.446 3.725l-6.446 3.757zM12 20.438a8.48 8.48 0 0 1-6.973-3.685l7.247-4.219.016-.009 7.283-4.241A8.438 8.438 0 0 1 12 20.438" fill="currentColor" />
    </BaseIcon>
  );
}
